import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flex items-center justify-between" }
const _hoisted_2 = { class: "flex flex-1 items-center" }
const _hoisted_3 = { class: "mr-2 flex space-x-1" }
const _hoisted_4 = { class: "mr-2 flex space-x-1" }
const _hoisted_5 = {
  key: 0,
  class: "flex space-x-1"
}
const _hoisted_6 = { class: "sr-only" }
const _hoisted_7 = { class: "mt-2 sm:flex sm:justify-between" }
const _hoisted_8 = { class: "sm:flex sm:space-x-4" }
const _hoisted_9 = { class: "flex items-center text-sm text-gray-500" }
const _hoisted_10 = { class: "flex items-center text-sm text-gray-500 sm:ml-0 sm:mt-0" }
const _hoisted_11 = { class: "mt-2 flex flex-wrap justify-between border-t pt-3" }
const _hoisted_12 = { class: "mb-1 grid gap-3 sm:mb-0 sm:grid-cols-3" }
const _hoisted_13 = { class: "flex items-center space-x-1 text-xs text-gray-600" }
const _hoisted_14 = { class: "ml-1" }
const _hoisted_15 = { class: "flex items-center space-x-1 text-xs text-gray-600" }
const _hoisted_16 = { class: "truncate" }
const _hoisted_17 = { class: "truncate" }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { class: "flex items-center space-x-1 text-xs text-gray-600" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UiIsActiveBadge = _resolveComponent("UiIsActiveBadge")!
  const _component_UiButton = _resolveComponent("UiButton")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_UiActionButton = _resolveComponent("UiActionButton")!
  const _component_UiPanel = _resolveComponent("UiPanel")!
  const _directive_tippy = _resolveDirective("tippy")!

  return (_openBlock(), _createBlock(_component_UiPanel, { class: "hover:bg-white" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.$can($setup.Permission.VIEW_CONTACT) ? 'RouterLink' : 'span'), {
            to: {
                        name: 'ViewContactById',
                        params: {
                            id: $props.modelValue.id,
                        },
                    },
            class: "text-md text-primary truncate font-medium"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString($props.modelValue.name), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["to"])),
          _createVNode(_component_UiIsActiveBadge, {
            "model-value": $props.modelValue,
            class: "ml-2 text-xs"
          }, null, 8 /* PROPS */, ["model-value"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode($setup["ContactHealthScoreBadge"], {
            "health-score": $props.modelValue.healthScore
          }, null, 8 /* PROPS */, ["health-score"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          (_ctx.$can($setup.Permission.VIEW_CONTACT_TIMELINE))
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                to: {
                        name: 'ViewContactTimelineById',
                        params: {
                            id: $props.modelValue.id,
                        },
                    }
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_UiButton, {
                    variant: "white",
                    "text-variant": "primary"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('contact.list.actions.viewTimeline')), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  })
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["to"]))
            : _createCommentVNode("v-if", true)
        ]),
        (_ctx.$can($setup.Permission.EDIT_CONTACT))
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _withDirectives((_openBlock(), _createBlock(_component_UiActionButton, {
                variant: "primary",
                class: "rounded-full",
                to: {
                        name: 'EditContactById',
                        params: {
                            id: $props.modelValue.id,
                        },
                    }
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('core.actions.Edit')), 1 /* TEXT */),
                  _createVNode($setup["PencilAltIcon"], {
                    class: "h-6 w-6",
                    "aria-hidden": "true"
                  })
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["to"])), [
                [_directive_tippy, _ctx.$t('core.actions.Edit')]
              ])
            ]))
          : _createCommentVNode("v-if", true)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("p", _hoisted_9, [
            _createVNode($setup["MailIcon"], {
              class: "mr-1.5 h-5 w-5 flex-shrink-0 text-gray-400",
              "aria-hidden": "true"
            }),
            _createTextVNode(" " + _toDisplayString($props.modelValue.emails.find((e) => e.isMain)?.email || _ctx.$t('contact.list.noEmail')), 1 /* TEXT */)
          ]),
          _createElementVNode("p", _hoisted_10, [
            _createVNode($setup["PhoneIcon"], {
              class: "mr-1.5 h-5 w-5 flex-shrink-0 text-gray-400",
              "aria-hidden": "true"
            }),
            _createTextVNode(" " + _toDisplayString($setup.applyPhoneMask($props.modelValue.phones.find((p) => p.isMain)!.number) || ''), 1 /* TEXT */)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('contact.list.owner')) + ": ", 1 /* TEXT */),
            _createElementVNode("div", _hoisted_14, _toDisplayString($props.modelValue.ownerUser.name), 1 /* TEXT */)
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('contact.list.lastInteraction')) + ": ", 1 /* TEXT */),
            ($props.modelValue.lastInteraction)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("span", _hoisted_16, _toDisplayString($setup.formatDateAsString($props.modelValue.lastInteraction?.toString(), 'DD/MM/YYYY')), 1 /* TEXT */),
                  _createElementVNode("span", _hoisted_17, _toDisplayString($setup.formatDateAsString($props.modelValue.lastInteraction?.toString(), 'HH:mm:ss')), 1 /* TEXT */)
                ], 64 /* STABLE_FRAGMENT */))
              : (_openBlock(), _createElementBlock("span", _hoisted_18, "-"))
          ]),
          _createElementVNode("div", _hoisted_19, [
            ($setup.sentiment)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("span", null, _toDisplayString($setup.sentiment.face), 1 /* TEXT */),
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t($setup.sentiment.label)), 1 /* TEXT */)
                ], 64 /* STABLE_FRAGMENT */))
              : _createCommentVNode("v-if", true)
          ])
        ]),
        _createVNode($setup["UiAuditInfo"], { "model-value": $props.modelValue }, null, 8 /* PROPS */, ["model-value"])
      ])
    ]),
    _: 1 /* STABLE */
  }))
}